require.register("app/product/stat/RestaurantCARankView", function(exports, require, module){
  $0
  
});

